import Pagenation from "components/Pagenation";
import { Link } from "react-router-dom";
import * as dbmsApi from "../../apis/DbmsApi";
import { apiWrapper } from "apis/CommonApi";
import { useEffect, useState } from "react";
import { getDateTime } from "utils/date";

//외부 API 연동 관리
export default function ExternalApiIntegrationComponent() {
  const itemsPerPage = 100;
  const [searchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [previous, setPrevious] = useState(null);
  const [next, setNext] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    getData(1);
  }, []);

  //page: 1베이스
  const getData = (page, url = null) => {
    const testData = [
      {
        "id": 1,
        "fireReceiverId": "화재수신기ID",
        "postUrl": "www.naver.com",
        "loginId": "아이디",
        "loginPw": "1234",
        "key": "1234567",
        "startDate": "2025-05-01",
        "endDate": "2025-05-10",
      }
    ];
    setDataSource(testData);

    apiWrapper(async () => {
      let result;
      //수정 필요
      if (url !== null) {
        result = await dbmsApi.getBusinessUserListByUrl(url);
      } else {
        result = await dbmsApi.getBusinessUserList(
          searchText,
          page,
          itemsPerPage
        );
      }

      const { status, data } = result;
      if (status === true) {
        //setDataSource(data);

        setPrevious(data.previous);
        setNext(data.next);
        setPage(page);
      } else {
        alert(`${data}`);
      }
    });
  };

  const handleChangeSearchText = (e) => {
    setSearchText(e.target.value);
  }

  const handleSearch = (e) => {
    if (e.type === "click" || (e.type === "keydown" && e.keyCode === 13)) {
      getData(page);
    }
  }

  const handleExportExcel = () => {
    apiWrapper(async () => {
      const { status, data } = await dbmsApi.downloadExcelBusinessUserList();
      alert(`${data}`);
    });
  }

  const handlePageArrowClick = (page, isNext) => {
    let url = null;
    if (isNext === false) {
      url = previous;
    } else {
      url = next;
    }

    getData(page, url);
  }

  return (
    <>
      <div class="viewBoard viewDBMSBoard AACBoard">

        <div class="top_board pc">
          <p class="title_board">외부 API 접속 관리</p>
          <div class="wrap_search openSearch">
            <div class="box_search">
              <div class="select_box">
                <button class="btn_select">
                  <p>화재수신기 일련번호</p>
                </button>
              </div>
              <input class="" type="text" placeholder="검색어를 입력해주세요." onChange={handleChangeSearchText} onKeyDown={handleSearch} defaultValue={searchText} />
              <button class="btn_search" onClick={handleSearch}>
                <i class="x-icon icon_search"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="top_board mb">
          <div class="wrap_logo">
            {/* <!-- <img src="" alt="" class="img_logo"> --> */}
          </div>
          <div class="header_dept">
            <p class="user">COWORKER</p>
            <div class="wrap_contr">
              <Link class="set_contr" to="">
                {/* <img src="/images/my_btn_mb.png" alt=""> */}
              </Link>
            </div>
          </div>
        </div>
        <div class="top_board navi_board mb">
          <Link class="wrap_navi" to="/">
            <p class="title_navi">외부 API 접속 관리</p>
          </Link>
          <div class="wrap_right mb">
            <Link class="btn_page_left" to="/dbmsMenu.html">
              <i class="x-icon"></i>
            </Link>
          </div>
        </div>

        <div class="table_board ">
          <table class="admin-table uam-table">
            <colgroup>
              <col width="10%" />
              <col width="25%" />
              <col width="25%" />
              <col width="15%" />
              <col width="15%" />
              <col width="15%" />
              <col width="15%" />
              <col width="15%" />
            </colgroup>
            <thead class="admin-thead">
              <tr class="admin-tr">
                <th class="admin-th">
                  <p>관리ID</p>
                </th>
                <th class="admin-th">
                  <p>화재수신기 ID</p>
                </th>
                <th class="admin-th">
                  <p>Post URL</p>
                </th>
                <th class="admin-th">
                  <p>접속ID</p>
                </th>
                <th class="admin-th">
                  <p>접속PW</p>
                </th>
                <th class="admin-th">
                  <p>발행인증키</p>
                </th>
                <th class="admin-th">
                  <p>접속허용시작일시</p>
                </th>
                <th class="admin-th">
                  <p>접속허용종료일시</p>
                </th>
              </tr>
            </thead>
            <tbody class="admin-tbody">
              {dataSource.results &&
                dataSource.results.map((item, index) => (
                  <tr class="admin-tr">
                    <td class="admin-td">
                      {item.id}
                    </td>
                    <td class="admin-td">
                      {item.fireReceiverId}
                    </td>
                    <td class="admin-td">
                      {item.postUrl}
                    </td>
                    <td class="admin-td">
                      {item.loginId}
                    </td>
                    <td class="admin-td">
                      {item.loginPw}
                    </td>
                    <td class="admin-td">
                      {item.key}
                    </td>
                    <td class="admin-td">
                      {getDateTime(new Date(item.startDate))}
                    </td>
                    <td class="admin-td">
                      {getDateTime(new Date(item.endDate))}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div class="wrap_controll type-start">
          <div class="wrap_dbms_btn">
            <button class="item_btn" onClick={handleExportExcel}>엑셀</button>
          </div>
          <div id="pagination">
            <Pagenation
              totalItemsCount={dataSource.count}
              itemsPerPage={itemsPerPage}
              selectedPage={page}
              setPage={(value) => setPage(value)}
              handlePageArrowClick={handlePageArrowClick}
            />
          </div>
        </div>

      </div>
    </>
  );
}
